/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Head from 'next/head';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import PageHeader from '../../components/PageHeader';
import NevoBanner from '../../components/NevoBanner';
import Points from '../../components/Points';
import ImagePointsSection from '../../components/ImagePointsSection';
import YoutubeEmbed from '../../components/YouTubeEmbed';

import eventGTM from '../../lib/gtag';
import links from '../../helper/links';

import styles from './styles.module.scss'
import EnergyBackground from '../../public/assets/images/energy-background.jpg';
import NevoESBLogo from '../../public/assets/images/nevo-esb-logo.png';
import EVFleetImage from '../../public/assets/images/ev-fleet.jpg';
import ESBTotalSolutionsImage from '../../public/assets/images/esb-total-solutions.png';
import ESBBenefitsImage from '../../public/assets/images/esb-benefits.jpg';

export default function EnergyPage()  {
  return (
    <>
      <Head>
        <title>Energy | Nevo Advisory</title>
      </Head>

      <Header black transparent />

      <PageHeader backgroundImage={EnergyBackground.src} className={styles.energyHeader}>
        <h1 className='page-header-h1'>Energy.</h1>
      </PageHeader>

      <div className={`${styles.energyPage} page-holder`}>
        <div className={styles.energyIntroContent}>
          <img className={styles.nevoESBLogo} src={NevoESBLogo.src} alt='Nevo | ESB (Energy For Generations)'/>

          <h2 className={`${styles.header} perfect-header`}>Connecting and decarbonising communities with sustainable infrastructure through strategic partnerships.</h2>

          <YoutubeEmbed videoURL={links.esb_youtube_video} className={styles.esbVideo} />

          <p className={`${styles.subHeader} perfect-subtext`}>In the pursuit of a cleaner and greener future, the electrification of transport is a key component of Ireland&apos;s sustainability strategy. Through strategic collaborations and innovative initiatives, ESB&apos;s Smart Energy Services has played a pivotal role in supporting the electrification of transport beyond the public charging infrastructure.</p>
        </div>

        <div className={styles.energyContent}>
          <img className={styles.image} src={EVFleetImage.src} alt='EBS Smart Energy Services delivering on the electrification of transport' />

          <p className={`${styles.electrificationText} perfect-bio`}>The electrification of transport is an essential component of any decarbonisation strategy. Whether you want to improve green credentials by electrifying your organisation&apos;s fleet, or meet the evolving needs of staff and customers, our expert team will deliver the electric vehicle (EV) charging infrastructure that&apos;s right for your organisation. We will work in partnership with you to design, install and maintain a custom charging infrastructure. We helped to build the world&apos;s first national network of EV charging points. Now, we&apos;re offering our expertise to help organisations like yours to drive the green energy revolution.</p>

          <Points 
            className={styles.businessPoints}
            header='We support businesses switch its fleet to Electric Vehicles by:'
            points={[
              "Gaining insights into your site’s existing supply, assess capacity for infrastructure, and understand your electric vehicle transition needs.",
              "Providing renewable energy solutions so you can harness clean energy sources, including solar and wind power, to power your electric vehicle charging infrastructure.",
              "Offering charging recommendations with tailored advice on the types, quantities, and speed output of chargers best suited for your fleet.",
              "Exploring cutting-edge design solutions tailored to your electric vehicle charging infrastructure.",
              "Delivering a turnkey solution: from concept to implementation, we provide seamless end-to-end services for your EV transition.",
              "Ensuring ongoing support, training, and maintenance for charger and charge management systems, along with continuous support.",
              "Guaranteeing maximum charger reliability and uptime to keep your operations uninterrupted."
            ]}
          />

          <h2 className={styles.totalHeader}>Total energy solutions provided by ESB&apos;s Smart Energy Services</h2>

          <img className={`${styles.image} ${styles.totalSolutionsImage}`} src={ESBTotalSolutionsImage.src} alt='ESB Total Solutions. 1.Solar Roof, 2.Wind Turbine, 3.CHP, 4.Energy Storage Hydrogen, 5.EV Electric Fleet, 6.Smart Lightining, 7.Ground Mount Solar, 8.Carport Solar Panels, 9.Air Source Heat Pumps, 10.Battery, 11.Corporate CPPA, 12.Energy Monitoring, 13.Ground Source Heat Pumps, 14.Extraction Well.' />

          <ImagePointsSection 
            switchDirection
            image={ESBBenefitsImage.src}
            noTransformImage
            biggerTextHolder
            pointsHeader='Some of the benefits of EV Charging with ESB’s Smart Energy Services'
            points={[
              "Future-proof Infrastructure",
              "Carbon Reduction",
              "Enhanced Green Credentials",
              "Suitable for Commuters & Commercial Fleets",
              "Greater Convenience for Staff & Customers"
            ]}
          />

          <div className={styles.esbCTAHolder}>
            <h1 className={`${styles.ctaHeader} perfect-header`}>
              Talk to us today
            </h1>
            
            <p className={`${styles.ctaText} perfect-subtext`}>
              Our unwavering commitment to supporting the electrification of transport is helping to transform the landscape of sustainable mobility in Ireland.<br/><br/> 
              Decarbonise your transport and move your organisation forward.
            </p>

            <a className={styles.buttonHolder} href={links.esb_link} rel='noreferrer' target='_blank'>
              <button className={`${styles.actionButton} blue-button action-button`} onClick={() => eventGTM('esbRequestACallbackClick')}>
                Request a Callback
              </button>
            </a>
          </div>
        </div>
      </div>

      <NevoBanner />

      <Footer />
    </>
  )
};
